import useI18n from '@/shared/hooks/useI18n'
import { Link } from 'react-router-dom'
import OperatorPeriodCard from './OperatorPeriodCard'
import { RouteProductionMethod } from '@/features/production-routes/api/ProductionRouteModel'
import { useGetReportsForInstallation } from '@/hooks/api/v2/reports'
import { useGetFinalizedReportsForInstallation } from '@/hooks/api/v2/finalizedReports'
import useProductionRouteReportingStatus from '@/hooks/useProductionRouteStatus'
import { Card, CardBody, ReportingPeriodBasis } from '@/common'

export default function ProductionRouteListItem({
  id,
  name,
  productionMethods,
  reportingPeriods,
  reportingPeriodBasis,
  pivotDate,
  installationId
}: {
  id: string
  name: string
  productionMethods: RouteProductionMethod[]
  reportingPeriodBasis: ReportingPeriodBasis
  reportingPeriods: {
    startDate: Date
    endDate: Date
  }[]
  pivotDate: Date
  installationId: string
}) {
  const { t } = useI18n()
  const finalizedReportsQuery = useGetFinalizedReportsForInstallation(installationId)
  const finalizedReports = finalizedReportsQuery.data ?? []
  const reportsQuery = useGetReportsForInstallation(installationId)
  const reports = reportsQuery.data ?? []

  const productionRouteStatuses = useProductionRouteReportingStatus({
    productionRouteId: id,
    pivotDate,
    reportingPeriods,
    finalizedReports,
    reports,
    reportingPeriodBasis
  })

  const allMethodsString = productionMethods
    .map(({ code }) => {
      return t(`common:productionMethods.${code}`)
    })
    .join(' => ')

  return (
    <li>
      <Card>
        <CardBody className="px-4 py-2 flex flex-col lg:flex-row gap-2">
          <div className="flex-1 flex flex-col justify-center gap-1.5">
            <Link
              to={`/dashboard/${installationId}/production-routes/${id}/view`}
              className="w-fit text-blue-500"
            >
              {name}
            </Link>
            <p className="text-sm text-gray-600">{allMethodsString}</p>
          </div>
          {productionRouteStatuses && (
            <>
              {productionRouteStatuses.previousPeriod && (
                <OperatorPeriodCard
                  periodId={productionRouteStatuses.previousPeriod.periodId}
                  status={productionRouteStatuses.previousPeriod.status}
                  label={productionRouteStatuses.previousPeriod.label}
                  installationId={installationId}
                  productionRouteId={id}
                />
              )}
              <OperatorPeriodCard
                periodId={productionRouteStatuses.currentPeriod.periodId}
                status={productionRouteStatuses.currentPeriod.status}
                label={productionRouteStatuses.currentPeriod.label}
                installationId={installationId}
                productionRouteId={id}
              />
            </>
          )}
        </CardBody>
      </Card>
    </li>
  )
}
